export const COST_REVIEW_TIMEOUT_ERROR = 'COST_REVIEW_TIMEOUT_ERROR';
export const VALIDATION_TIMEOUT_ERROR = 'VALIDATION_TIMEOUT_ERROR';
